export const getHoveredIndex = (
  offsetX: number,
  width: number,
  pointsCount: number
): number | null => {
  if (!pointsCount || width <= 0) {
    return null;
  }

  const ratio = offsetX / width;

  if (ratio < 0 || ratio > 1) {
    return null;
  }

  return pointsCount === 1 ? 0 : Math.round(ratio * (pointsCount - 1));
};
